import {Component, h} from '@stencil/core';

@Component({
  tag: 'nest-notices',
  styleUrl: 'nest-notices.scss',
  shadow: true,
})
export class NestNotices {

  render() {
    return <div class={'nest-notices'}>
      <slot></slot>
    </div>;
  }
}
